/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';

// 查询案件列表
export const getCaseList = easyPost('common.reunion.list', { api: `${config.API}/getCaseList` });

// 查看案件详情
export const getCaseDetail = easyPost('common.reunion.detail', { api: `${config.API}/getInfoByCaseId` });
